export default __webpack_public_path__ + "static/media/step16.6e15170c.svg";